import Vue from "vue";
import App from "./App.vue";

import CoreuiVue from "@coreui/vue";

import router from "./router/index";
import store from "./store/index";

import DatePicker from "vue2-datepicker";

Vue.use(DatePicker);

import VueTheMask from "vue-the-mask";

Vue.use(VueTheMask);

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBicycle,
  faPlus,
  faEye,
  faBuilding,
  faGavel,
  faComment,
  faMotorcycle,
  faTable,
  faAddressCard,
  faCity,
  faEyeSlash
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faGavel,
  faPlus,
  faEye,
  faEyeSlash,
  faMotorcycle,
  faComment,
  faBicycle,
  faBuilding,
  faTable,
  faAddressCard,
  faCity
);

import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

library.add(faWhatsapp);

Vue.component("font-awesome-icon", FontAwesomeIcon);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "pt" // set locale
});
Vue.prototype.$vueEventBus = new Vue();

import { iconsSet as icons } from "./assets/icons/icons.js";

// import BootstrapVue from "bootstrap-vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// Vue.use(BootstrapVue);

Vue.config.performance = true;
Vue.use(CoreuiVue);

// import "es6-promise/auto";
import VueMask from "v-mask";
import VeeValidate from "vee-validate";
import VueMeta from "vue-meta";

import * as VueGoogleMaps from "vue2-google-maps";

import TheContainer from "../src/components/TheContainer.vue";
// import Chat from "vue-beautiful-chat";

const config = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: null,
  errorBagName: "errors", // change if property conflicts
  events: "input|blur",
  fieldsBagName: "fields",
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: "validations", // the nested key under which the validation messages will be located
  inject: true,
  locale: "en",
  validity: false,
  useConstraintAttrs: true
};

// Vue.use(Chat);
Vue.use(TheContainer);
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});
Vue.use(VeeValidate, config);
Vue.use(VueMask);
// Vue.use(Vuetify);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyADQgErkcBvABNO8xYLEzTWzflYkbbc8E8"
  }
});

Vue.config.productionTip = false;

const axios = require("axios");

axios.interceptors.response.use(
  response => {
    return response;
  },
  function(error) {
    const originalRequest = error.config;
    if (error.response != null) {
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        return axios
          .post(sessionStorage.getItem("url") + "/api/refresh_token", {
            headers: { Authorization: "Bearer " + store.getters.getToken },
            access_token: store.getters.getToken
          })
          .then(res => {
            if (res.status === 200) {
              // 1) put token to LocalStorage
              store.commit("SET_TOKEN", res.data.access_token);

              // 2) Change Authorization header
              axios.defaults.headers.common["Authorization"] =
                "Bearer " + store.getters.getToken;

              // 3) return originalRequest object with Axios.
              return axios(originalRequest);
            }
          });
      } else if (error.response.status === 412) {
        router.push({ path: "/" });

        store.commit("DESTROY_USER");
      } else if (error.response.status === 503) {
        router.push({ path: "/manutencao" });
      } else {
        return Promise.reject(error);
      }
    } else {
      router.push({ path: "/manutencao" });
    }
    // return Error object with Promise
    return Promise.reject(error);
  }
);

new Vue({
  el: "#app",
  name: "teste",
  i18n,
  icons,
  store,
  router,
  render: h => h(App)
});
